import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-red-500 base" }

import {ref} from "vue";

import { Modal } from "flowbite-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorModal',
  props: {
  isShown: Boolean,
  errorMessage: String,
},
  emits: ["close"],
  setup(__props, { emit }) {

const props = __props;







return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (__props.isShown)
    ? (_openBlock(), _createBlock(_unref(Modal), {
        key: 0,
        onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, {
        body: _withCtx(() => [
          _createElementVNode("h1", _hoisted_1, [
            _createVNode(_component_font_awesome_icon, {
              icon: "fa-solid fa-exclamation",
              size: "2xl",
              style: {"color":"#dc2626"}
            }),
            _createTextVNode(" " + _toDisplayString(__props.errorMessage), 1)
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})